import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import { Link } from 'react-router-dom';

var _excluded = ["index", "onClick", "url", "text", "theme", "externalLink"];
var _templateObject, _templateObject2;
var StyledListItem = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: 48px;\n  transition: color 0.1s;\n  align-items: center;\n  &:last-child {\n    & > div {\n      border-right: none;\n    }\n  }\n\n  @media (max-width: 768px) {\n    height: 60px;\n    border-top:", "\n    border-right: none;\n    width: auto;\n    margin-left: 5%;\n    margin-right: 5%;\n    align-items: center;\n    text-align: left;\n    &:last-child {\n      & > div {\n        border-top: none;\n      }\n    }\n  }\n\n  @media (min-width: 769px) {\n    flex: 1;\n    height: 48px;\n  }\n\n\n\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.palette['grayLighter'], " solid 2px;");
});
var StyledLinkContainer = styled('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex: 1\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 45%;\n    padding-left: 2%;\n    padding-right: 2%;\n    border-right:", "\n\n    a {\n        font-weight: 500;\n        text-align: center;\n        \n        color: ", ";\n        font-size: calc(1rem + (2 * (100vw - 768px)) / 882);\n        transition: color 0.1s;\n        :hover {\n            color: ", ";\n            text-decoration: none;\n        }   \n    }\n\n\n    @media (max-width: 768px) {\n      border-right: none;\n      justify-content: flex-start;\n      a {\n        font-size: 1.25rem;\n      }\n    }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.palette['grayLighter'], " solid 2px;");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette['grayDark'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette['primary'];
});
var ListItem = function ListItem(_ref5) {
  var _ref5$index = _ref5.index,
    index = _ref5$index === void 0 ? 0 : _ref5$index,
    onClick = _ref5.onClick,
    url = _ref5.url,
    text = _ref5.text,
    theme = _ref5.theme,
    _ref5$externalLink = _ref5.externalLink,
    externalLink = _ref5$externalLink === void 0 ? false : _ref5$externalLink,
    rest = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(StyledListItem, _extends({}, rest, {
    key: "banner-item-".concat(index),
    theme: theme
  }), /*#__PURE__*/React.createElement(StyledLinkContainer, {
    key: "banner-linkC-".concat(index),
    theme: theme
  }, externalLink ? /*#__PURE__*/React.createElement("a", {
    onClick: onClick,
    key: "banner-link-".concat(index),
    href: url
  }, text) : /*#__PURE__*/React.createElement(Link, {
    onClick: onClick,
    key: "banner-link-".concat(index),
    to: url
  }, text)));
};
var _ListItem = withDefaultTheme(ListItem);

export default _ListItem;
